import { queryByParams } from "./queryByParam";
import { fetchSanityData } from "./sanity-api";

export const getSanityDataByParams = async <T>(param: string, value: string): Promise<T[] | null> => {
  const query = queryByParams(param, value);
  return await fetchSanityData<T>(query);
};